import { useQuery } from "@tanstack/react-query";

import { queryKeys } from "../queryKeys";
import { getCountries } from "../rest/onboarding";

export const useGetCountries = () => {
  const { data: countries = [] } = useQuery({
    queryKey: queryKeys.countries(),
    queryFn: getCountries,
    // It's so unlikely that this will change, we can cache it forever
    staleTime: Infinity,
  });

  return {
    countries,
    countriesRaw: countries,
    alpha3ToName: (alpha3: string) =>
      countries.find(({ "alpha-3": short }) => short === alpha3)?.name,
    nameToAlpha3: (name: string) =>
      countries.find(({ name: n }) => n === name)?.["alpha-3"],
  };
};

export default useGetCountries;
